module.exports = __webpack_public_path__ + "static/media/logoRu.74bd2683.svg";